// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.list {
    width: 100%;
    margin: 0 auto;
    max-width: 800px;
}

.list .list-header {
    display: grid;
    grid-template-columns: 1fr, 1fr;
    grid-template-rows: auto;
    padding: 10px 20px;
}
.list .list-header h2 {
    grid-column: 1 / 2;
    padding: 0;
    margin: 0;
    font-weight: 400;
}
.list .list-header h2 svg {
    display: inline-block;
    width: 1em;
    height: 1em;
    margin-right: 6px;
    margin-bottom: -4px;
}
.list .list-header .controls {
    grid-column: 2 / 3;
    text-align: right;
}
.list .list-header .controls .list-control {
    display: inline-block;
    padding: 5px;
    margin: 0 10px;
}

.list .list-row-content {}
.list .list-grid-content {
    display: grid;
    margin: 0 auto;
    grid-template-columns: repeat(auto-fit, 400px);
}
.list .list-no-content {
    padding: 20px;
    text-align: center;
}

@media ( width < 400px) {
    .list .list-grid-content {
        box-sizing: border-box;
        grid-template-columns: repeat(auto-fit, 360px);
    }
}

`, "",{"version":3,"sources":["webpack://./client/components/generic/list/List.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,+BAA+B;IAC/B,wBAAwB;IACxB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,qBAAqB;IACrB,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,qBAAqB;IACrB,YAAY;IACZ,cAAc;AAClB;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,cAAc;IACd,8CAA8C;AAClD;AACA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI;QACI,sBAAsB;QACtB,8CAA8C;IAClD;AACJ","sourcesContent":[".list {\n    width: 100%;\n    margin: 0 auto;\n    max-width: 800px;\n}\n\n.list .list-header {\n    display: grid;\n    grid-template-columns: 1fr, 1fr;\n    grid-template-rows: auto;\n    padding: 10px 20px;\n}\n.list .list-header h2 {\n    grid-column: 1 / 2;\n    padding: 0;\n    margin: 0;\n    font-weight: 400;\n}\n.list .list-header h2 svg {\n    display: inline-block;\n    width: 1em;\n    height: 1em;\n    margin-right: 6px;\n    margin-bottom: -4px;\n}\n.list .list-header .controls {\n    grid-column: 2 / 3;\n    text-align: right;\n}\n.list .list-header .controls .list-control {\n    display: inline-block;\n    padding: 5px;\n    margin: 0 10px;\n}\n\n.list .list-row-content {}\n.list .list-grid-content {\n    display: grid;\n    margin: 0 auto;\n    grid-template-columns: repeat(auto-fit, 400px);\n}\n.list .list-no-content {\n    padding: 20px;\n    text-align: center;\n}\n\n@media ( width < 400px) {\n    .list .list-grid-content {\n        box-sizing: border-box;\n        grid-template-columns: repeat(auto-fit, 360px);\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
